<template>
  <section class="mx-auto bg-[#181818] p-12 text-white md:px-12 lg:max-w-4xl lg:px-20">
    <h2 class="mb-4 text-xl font-semibold text-orange-400">My Journey</h2>
    <div class="space-y-5 text-justify">
      <p>
        My path into tech started with a Lego robotics course back in high school. That hands-on
        experience, combined with hours spent experimenting in Game Maker Studio, gave me an early
        glimpse into how satisfying it could be to build things. It wasn’t long before I realized
        coding wasn’t just fun — it was something I wanted to pursue seriously. So I chose Systems
        Engineering as my career.
      </p>
      <p>
        What really solidified that decision was a project I built in C during university — a
        simple, turn-based battlefield game. What stood out wasn’t just the code or the challenge;
        it was the experience of watching my classmates play and enjoy something I created. That
        moment taught me one of my favorite things about being a developer: delivering software that
        others actually enjoy using.
      </p>
      <p>
        Since then, I’ve worked full-time in both web development and data engineering. I’ve helped
        build a customizable Nuxt + WordPress site as part of an outsourced dev team, and I’ve
        worked in the banking sector building ETL pipelines and dashboards. I like solving problems
        that have real-world value — whether that’s through a clean user interface or a reliable
        backend data flow.
      </p>
      <p>
        Although I learned a lot in university, much of what I use every day — JavaScript, HTML,
        CSS, Python, Django REST Framework, and Vue — I taught myself through experience,
        experimentation, and on-the-job learning. Over time, I’ve learned to focus less on
        perfectionism and more on delivering code that works and solves real problems. I prioritize
        what matters most for the client, balancing wants against needs.
      </p>
      <p>
        Now, I’m taking everything I’ve learned to continue building meaningful tools for real
        people, and find the same satisfaction I felt when I saw my first users enjoy something I
        built.
      </p>
    </div>
  </section>
</template>
